module.exports = __webpack_public_path__ + "static/media/nourish.d90d0905.jpg";